module.exports = __webpack_public_path__ + "static/media/collapsible-icon.93ae882e.svg";